<template>
  <div>
    <span class="helloBn"><a @click="dialogVisible = true">忘记密码？</a></span>
    <el-dialog
      v-model="dialogVisible"
      width="30%"
      v-bind="$attrs"
      @close="onClose"
      title="账户密码找回"
      :close-on-click-modal="false"
    >
      <el-row :gutter="15">
        <el-form
          ref="elForm"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="24">
            <el-row>
              <el-col :span="20">
                <el-form-item label="手机号" prop="userPhoneNum">
                  <el-input
                    v-model="formData.userPhoneNum"
                    placeholder="请输入您的手机号"
                    :maxlength="11"
                    show-word-limit
                    clearable
                    prefix-icon="el-icon-phone"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <span id="msg"
                  >*
                  请输入您注册时所用的手机号，您的账户密码会通过短信发送至您的手机</span>
              </el-col>
            </el-row>
          </el-col>
        </el-form>
      </el-row>
      <template #footer>
        <div>
          <el-button @click="onClose">取消</el-button>
          <el-button type="primary" @click="findBackAccount"
            >我要找回</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {
        userPhoneNum: ''
      },
      rules: {
        userPhoneNum: [
          {
            required: true,
            message: '请输入账户注册的手机号',
            trigger: 'blur'
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.dialogVisible = false
      this.$refs.elForm.resetFields()
    },
    findBackAccount () {
      this.$refs.elForm.validate(valid => {
        if (valid) {
          this.doFindBack()
        }
      })
    },
    doFindBack () {
      const api = '/md/front/user/findBackAccount'
      const params = {
        phoneNum: this.formData.userPhoneNum
      }
      this.axios.post(api, this.$stringify(params)).then((res) => {
        if (res.status === 200) {
          this.$alert('找回成功，请查看您的手机', '提示')
          this.dialogVisible = false
          this.$refs.elForm.resetFields()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
#msg {
  padding: 0 0 0 40px;
  text-align: left;
  display: inline-block;
  font-size: 14px;
  color: #999999;
}
.helloBn {
    position: relative;
   font-size: 22px;
   cursor: pointer;
   margin-left: 30px;
   color: #fff;
   top: 5px;
}

.helloBn a:hover {
   color: crimson;
   top: 5px;
}
</style>
